import { E_BinanceTransactionType, SelectHistoryTransactionOptions } from '@/redux/transactions/transactions.types'

export const options: SelectHistoryTransactionOptions<E_BinanceTransactionType>[] = [
  { label: 'TRANSFER', value: E_BinanceTransactionType.TRANSFER },
  { label: 'WELCOME_BONUS', value: E_BinanceTransactionType.WELCOME_BONUS },
  { label: 'REALIZED_PNL', value: E_BinanceTransactionType.REALIZED_PNL },
  { label: 'FUNDING_FEE', value: E_BinanceTransactionType.FUNDING_FEE },
  { label: 'COMMISSION', value: E_BinanceTransactionType.COMMISSION },
  { label: 'INSURANCE_CLEAR', value: E_BinanceTransactionType.INSURANCE_CLEAR },
]
